/**
 * Quantity Break — "buy more, save more" tier widget.
 * Selecting a tier reveals one color/size picker per unit in that tier, so the
 * customer can choose a different variant for each item. Add-to-cart adds every
 * chosen variant under the tier's discount. Tier prices are projections from a
 * representative unit price; the real reduction is applied at checkout by a
 * native Shopify automatic quantity discount.
 */
(function () {
  if (customElements.get('quantity-break')) return;

  function money(cents) {
    try {
      if (typeof window.formatPrice === 'function' && window.theme && window.theme.settings) {
        return window.formatPrice(cents, window.theme.settings.money_format);
      }
    } catch (e) {}
    return 'Dhs. ' + (cents / 100).toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  class QuantityBreak extends HTMLElement {
    connectedCallback() {
      this.tiers = Array.prototype.slice.call(this.querySelectorAll('[data-qb-tier]'));
      this.addBtn = this.querySelector('[data-add]');
      this.errorEl = this.querySelector('.qb__error');

      this.colorLabel = this.getAttribute('data-color-label') || 'Color';
      this.sizeLabel = this.getAttribute('data-size-label') || 'Size';
      this.baseCents = parseInt(this.getAttribute('data-base-price'), 10) || 0;
      this.singleVariant = parseInt(this.getAttribute('data-single-variant'), 10) || null;

      try { var cd = this.querySelector('[data-qb-colors]'); this.colors = cd ? JSON.parse(cd.textContent) : []; }
      catch (e) { this.colors = []; }
      try { var vd = this.querySelector('[data-qb-variants]'); this.variants = vd ? JSON.parse(vd.textContent) : []; }
      catch (e) { this.variants = []; }

      this.mode = this.colors.length ? 'colors' : (this.variants.length > 1 ? 'sizes' : 'single');

      this.selected = this.tiers.filter(function (t) { return t.classList.contains('is-selected'); })[0] || this.tiers[0];
      this.tiers.forEach(function (tier) {
        var head = tier.querySelector('.qb__tier-head');
        var pick = this.onTier.bind(this, tier);
        if (head) {
          head.addEventListener('click', pick);
          head.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
          });
        }
        // Interacting with the pickers must not bubble up and rebuild them.
        var lines = tier.querySelector('[data-qb-lines]');
        if (lines) lines.addEventListener('click', function (e) { e.stopPropagation(); });
      }.bind(this));

      if (this.addBtn) this.addBtn.addEventListener('click', this.onAdd.bind(this));

      this.recompute();

      // If the product page has a main Add-to-cart form, route through it:
      // nothing selected by default; picking a tier arms the shared coordinator.
      this.coordinated = !!(document.querySelector('product-form') && window.OfferCoordinator);
      this.offer = {
        label: this.offerLabel.bind(this),
        submit: this.onAdd.bind(this),
        deselect: this.deselectAll.bind(this)
      };
      if (this.coordinated) {
        if (this.addBtn) this.addBtn.style.display = 'none';
        this.deselectAll();
        window.OfferCoordinator.register(this.offer);
      } else {
        this.buildLines();
      }
      this.hideError();
    }

    onTier(tier) {
      if (this.coordinated) {
        if (tier === this.selected && window.OfferCoordinator.isActive(this.offer)) {
          this.deselectAll();
          window.OfferCoordinator.clear(this.offer);
          return;
        }
        this.select(tier);
        this.buildLines();
        window.OfferCoordinator.select(this.offer);
        return;
      }
      if (tier === this.selected) return; // already selected — keep its pickers intact
      this.select(tier);
      this.buildLines();
    }

    deselectAll() {
      this.selected = null;
      this.tiers.forEach(function (t) {
        t.classList.remove('is-selected');
        var i = t.querySelector('.qb__tier-input'); if (i) i.checked = false;
        var c = t.querySelector('[data-qb-lines]'); if (c) c.innerHTML = '';
      });
    }

    offerLabel() {
      if (!this.selected) return '';
      var t = this.selected;
      var qty = this.selectedQty();
      var base = this.basePrice();
      var type = t.getAttribute('data-type') || 'percent';
      var pct = parseFloat(t.getAttribute('data-percent')) || 0;
      var fixed = parseInt(t.getAttribute('data-fixed'), 10) || 0;
      var total = (type === 'fixed' && fixed > 0) ? fixed : Math.round(base * (100 - pct) / 100) * qty;
      return 'Add ' + qty + ' · ' + money(total);
    }

    select(tier) {
      this.selected = tier;
      this.tiers.forEach(function (t) {
        var on = t === tier;
        t.classList.toggle('is-selected', on);
        var input = t.querySelector('.qb__tier-input');
        if (input) input.checked = on;
      });
      this.hideError();
    }

    selectedQty() { return parseInt(this.selected.getAttribute('data-qty'), 10) || 1; }

    lineHtml(i) {
      var num = i + 1;
      var fields = '';
      if (this.mode === 'colors') {
        fields += '<label class="qb__field"><span class="qb__field-label">' + esc(this.colorLabel) + '</span>' +
          '<select class="qb__select" data-qb-line-color>' +
          this.colors.map(function (p) { return '<option value="' + p.id + '">' + esc(p.color) + '</option>'; }).join('') +
          '</select></label>';
        fields += '<label class="qb__field"><span class="qb__field-label">' + esc(this.sizeLabel) + '</span>' +
          '<select class="qb__select" data-qb-line-size></select></label>';
      } else {
        fields += '<label class="qb__field"><span class="qb__field-label">' + esc(this.sizeLabel) + '</span>' +
          '<select class="qb__select" data-qb-line-size>' +
          this.variants.map(function (v) {
            return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ' — Sold out') + '</option>';
          }).join('') +
          '</select></label>';
      }
      return '<div class="qb__line" data-qb-line>' +
        '<span class="qb__line-num">' + num + '</span>' +
        '<div class="qb__line-fields">' + fields + '</div></div>';
    }

    buildLines() {
      // Clear every tier's picker container, then fill only the selected one.
      this.tiers.forEach(function (t) {
        if (t !== this.selected) {
          var c = t.querySelector('[data-qb-lines]');
          if (c) c.innerHTML = '';
        }
      }.bind(this));

      var container = this.selected && this.selected.querySelector('[data-qb-lines]');
      if (!container) return;
      if (this.mode === 'single') { container.innerHTML = ''; return; }

      var qty = this.selectedQty();
      var html = '';
      for (var i = 0; i < qty; i++) html += this.lineHtml(i);
      container.innerHTML = html;

      var lines = Array.prototype.slice.call(container.querySelectorAll('[data-qb-line]'));
      lines.forEach(function (line) {
        var colorSel = line.querySelector('[data-qb-line-color]');
        if (colorSel) {
          colorSel.addEventListener('change', function () { this.fillSizes(line); }.bind(this));
          this.fillSizes(line);
        }
      }.bind(this));
      this.hideError();
    }

    fillSizes(line) {
      var colorSel = line.querySelector('[data-qb-line-color]');
      var sizeSel = line.querySelector('[data-qb-line-size]');
      if (!colorSel || !sizeSel) return;
      var id = parseInt(colorSel.value, 10);
      var p = this.colors.filter(function (c) { return c.id === id; })[0] || this.colors[0];
      if (!p) return;
      sizeSel.innerHTML = p.variants.map(function (v) {
        return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.size) + (v.available ? '' : ' — Sold out') + '</option>';
      }).join('');
      var fa = p.variants.filter(function (v) { return v.available; })[0];
      if (fa) sizeSel.value = fa.id;
    }

    basePrice() {
      if (this.baseCents) return this.baseCents;
      if (this.colors[0]) return this.colors[0].price;
      if (this.variants[0]) return this.variants[0].price;
      return 0;
    }

    recompute() {
      var base = this.basePrice();
      this.tiers.forEach(function (tier) {
        var qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;
        var type = tier.getAttribute('data-type') || 'percent';
        var pct = parseFloat(tier.getAttribute('data-percent')) || 0;
        var fixed = parseInt(tier.getAttribute('data-fixed'), 10) || 0;
        var full = base * qty;
        var total, unit;
        if (type === 'fixed' && fixed > 0) {
          total = fixed;
          unit = Math.round(fixed / qty);
        } else {
          unit = Math.round(base * (100 - pct) / 100);
          total = unit * qty;
        }
        var save = full - total;
        var off = full > 0 && save > 0 ? Math.round(save * 100 / full) : 0;
        var unitEl = tier.querySelector('[data-qb-unit]');
        var totalEl = tier.querySelector('[data-qb-total]');
        var wasEl = tier.querySelector('[data-qb-was]');
        var offEl = tier.querySelector('[data-qb-off]');
        if (unitEl) unitEl.textContent = money(unit);
        if (totalEl) totalEl.textContent = money(total);
        if (wasEl) { wasEl.textContent = money(full); wasEl.style.display = save > 0 ? '' : 'none'; }
        if (offEl) { offEl.textContent = '-' + off + '%'; offEl.style.display = off > 0 ? '' : 'none'; }
      });
    }

    showError(msg) { if (this.errorEl) { this.errorEl.textContent = msg || 'Please choose an option for each item'; this.errorEl.hidden = false; } }
    hideError() { if (this.errorEl) this.errorEl.hidden = true; }

    collectItems(props) {
      if (this.mode === 'single') {
        if (!this.singleVariant) return null;
        return [{ id: this.singleVariant, quantity: this.selectedQty(), properties: props }];
      }
      var container = this.selected && this.selected.querySelector('[data-qb-lines]');
      var sels = container ? Array.prototype.slice.call(container.querySelectorAll('[data-qb-line-size]')) : [];
      if (!sels.length) return null;
      var items = [], ok = true;
      sels.forEach(function (sel) {
        var opt = sel.selectedOptions[0];
        if (!sel.value || (opt && opt.disabled)) { ok = false; return; }
        items.push({ id: parseInt(sel.value, 10), quantity: 1, properties: props });
      });
      return ok && items.length ? items : null;
    }

    onAdd() {
      var pct = parseFloat(this.selected.getAttribute('data-percent')) || 0;
      var props = { '_qb_group': 'qb-' + Date.now() + '-' + Math.floor(Math.random() * 1e6) };
      var titleEl = this.selected.querySelector('.qb__tier-title');
      if (titleEl) props['Offer'] = titleEl.textContent.trim();
      if (pct > 0) props['_qb_percent'] = String(pct);

      var items = this.collectItems(props);
      if (!items) { this.showError(); return Promise.resolve(); }

      var btn = this.addBtn, label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (x) { return x.section; });
        body.sections_url = window.location.pathname;
      }
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) return r.json().then(function (b) { throw new Error(b.description || 'e'); }); return r.json(); })
        .then(function (resp) {
          if (drawer && typeof drawer.renderContents === 'function' && resp.sections) {
            drawer.renderContents(resp);
            if (typeof updateCartCounters === 'function') updateCartCounters();
            btn.disabled = false; btn.textContent = label;
          } else { window.location.href = '/cart'; }
        })
        .catch(function () { btn.disabled = false; btn.textContent = label; });
    }
  }
  customElements.define('quantity-break', QuantityBreak);
})();
